// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.professors-card {
	margin: 50px 0;
	width: 95%;
	max-width: 1600px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
	background-color: var(--primary-color);
	color: white;
	padding: 15px;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.header-title {
	margin: 0;
	font-size: 25px;
}

.search-container {
	display: flex;
	flex-wrap: wrap;
	padding: 15px 25px;
	gap: 10px;
}

.filter-header-container {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap-reverse;
	gap: 30px;
}

.search-title {
	font-size: 22px;
	margin: 0;
}

.search-group {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	flex: 1 1;
	min-width: 200px;
}

.search-group label {
	margin-bottom: 5px;
	font-size: 18px;
}

.search-group input,
.search-group select {
	max-width: 300px;
	height: 50px;
	padding: 8px;
	border-radius: 4px;
	font-size: 18px;
}

.filter-button-container {
	display: flex;
	justify-content: center;
	align-items: center;
}

.filter-button {
	background-color: var(--success-color);
	width: 100px;
	height: 40px;
	font-size: 1rem;
}

.filter-button:hover {
	background-color: rgb(5, 142, 5);
}

.card-body {
	padding: 25px;
}

.professors-table {
	width: 100%;
	border-collapse: collapse;
}

.professors-table th,
.professors-table td {
	border: 1px solid #ddd;
	padding: 10px;
	text-align: center;
	font-size: 18px;
}

.professors-table th {
	background-color: #f2f2f2;
	font-weight: bold;
}

.professors-table tr:nth-child(even) {
	background-color: #f9f9f9;
}

.last-name {
	width: 10%;
}

.prof-number {
	width: 6%;
}

.faculty {
	width: 10%;
}

.department {
	width: 12%;
}

.scientific-rank {
	width: 6%;
}

.action-table {
	width: 25%;
}

.actions {
	display: flex;
	justify-content: center;
	gap: 10px;
}

.action-button {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 6px 12px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	width: 85px;
}

.action-button.delete {
	background-color: var(--danger-color);
	color: white;
}

.action-button.suspend {
	background-color: var(--label-color);
	color: white;
}

.action-button.view {
	background-color: rgb(0, 88, 189);
	color: white;
}

.action-button.update {
	background-color: rgb(80, 200, 196);
	color: white;
}

.no-data {
	text-align: center;
	padding: 20px;
}

.pagination-container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
}

.pagination-btn {
	padding: 5px 10px;
	margin: 0 5px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #fff;
	cursor: pointer;
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pagination-btn.active {
	background-color: var(--primary-color);
	color: #fff;
}

.pagination-btn:disabled {
	background-color: #f4f4f4;
	cursor: not-allowed;
}

.dialog-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}

.dialog {
	background-color: white;
	padding: 20px;
	border-radius: 8px;
	width: 400px;
}

.dialog-title {
	font-size: 25px;
}

.dialog-content {
	margin-bottom: 20px;
	font-size: 20px;
}

.dialog-actions {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}

.dialog-button {
	padding: 8px 16px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	color: white;
	font-size: 1rem;
}

.dialog-button.cancel {
	background-color: var(--label-color);
}

.dialog-button.confirm {
	background-color: var(--danger-color);
}

.dialog-button.active {
	background-color: var(--success-color);
}

@media (max-width: 1200px) {
	.professors-list-container {
		height: 100vh;
	}

	.search-group input,
	.search-group select {
		height: 45px;
		font-size: 20px;
	}

	.filter-button {
		height: 35px;
	}

	.actions {
		flex-wrap: wrap;
	}
}

@media (max-width: 1090px) {
	.professors-list-container {
		height: 150vh;
	}
}

@media (max-width: 945px) {
	.search-group label {
		font-size: 1rem;
	}

	.search-group input,
	.search-group select {
		height: 35px;
		font-size: 1rem;
	}

	.filter-button {
		width: 85px;
		height: 30px;
		font-size: 1rem;
	}

	.professors-table th,
	.professors-table td {
		font-size: 16px;
		padding: 8px;
	}

	.action-button {
		width: 60px;
		font-size: 12px;
	}
}

@media (max-width: 768px) {
	.professors-list-container {
		height: 100vh;
	}

	.header-title {
		font-size: 20px;
	}

	.search-title {
		font-size: 18px;
	}

	.search-group label {
		font-size: 13px;
	}

	.search-group input,
	.search-group select {
		height: 30px;
		font-size: 13px;
	}

	.filter-button {
		width: 60px;
		height: 25px;
		font-size: 13px;
	}

	.card-body {
		padding: 10px;
	}

	.professors-table th,
	.professors-table td {
		font-size: 12px;
		padding: 2px;
	}

	.actions {
		gap: 3px;
	}

	.action-button {
		width: 45px;
		font-size: 8px;
		padding: 3px 6px;
	}

	.pagination-btn {
		width: 25px;
		height: 25px;
		font-size: 10px;
	}

	.dialog {
		width: 300px;
	}

	.dialog-title {
		font-size: 20px;
	}

	.dialog-content {
		margin-bottom: 10px;
		font-size: 1rem;
	}

	.dialog-button {
		padding: 4px 8px;
		font-size: 12px;
	}
}

@media (max-width: 576px) {
	.professors-card {
		height: 60vh;
	}

	.professors-card {
		width: 100%;
		height: 75vh;
	}

	.card-header {
		padding: 10px;
	}

	.header-title {
		font-size: 18px;
	}

	.search-container {
		margin-bottom: 120px;
	}

	.search-title {
		font-size: 1rem;
	}

	.search-container {
		padding: 10px;
		gap: 0;
		height: 60px;
	}

	.search-group label {
		font-size: 10px;
	}

	.search-group input,
	.search-group select {
		height: 25px;
		width: 60%;
		font-size: 10px;
	}

	.filter-button {
		width: 45px;
		height: 20px;
		font-size: 10px;
	}

	.card-body {
		padding: 10px;
	}

	.professors-table th,
	.professors-table td {
		font-size: 10px;
		padding: 2px;
	}

	.actions {
		gap: 1px;
	}

	.action-button {
		width: 35px;
		font-size: 8px;
		padding: 2px 4px;
	}

	.pagination-btn {
		width: 20px;
		height: 20px;
		font-size: 8px;
	}

	.dialog {
		width: 200px;
	}

	.dialog-title {
		font-size: 1rem;
	}

	.dialog-content {
		margin-bottom: 0;
		font-size: 13px;
	}

	.dialog-button {
		padding: 3px 6px;
		font-size: 10px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserManagement/UserManagement.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,UAAU;CACV,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,aAAa;CACb,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,WAAW;CACX,8BAA8B;CAC9B,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,SAAO;CACP,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;;CAEC,sBAAsB;CACtB,aAAa;CACb,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,YAAY;AACb;;AAEA;CACC,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC,iCAAiC;CACjC,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,oCAAoC;CACpC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,aAAa;CACb,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;;EAEC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;;EAEC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;;CAEA;;EAEC,eAAe;EACf,YAAY;CACb;;CAEA;EACC,WAAW;EACX,eAAe;CAChB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;;EAEC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;;CAEA;;EAEC,eAAe;EACf,YAAY;CACb;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;EACnB,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,eAAe;CAChB;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,MAAM;EACN,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;;EAEC,YAAY;EACZ,UAAU;EACV,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;;CAEA;;EAEC,eAAe;EACf,YAAY;CACb;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,cAAc;CACf;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,eAAe;CAChB;AACD","sourcesContent":[".professors-card {\n\tmargin: 50px 0;\n\twidth: 95%;\n\tmax-width: 1600px;\n\tbackground-color: #fff;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n\tbackground-color: var(--primary-color);\n\tcolor: white;\n\tpadding: 15px;\n\tborder-top-left-radius: 8px;\n\tborder-top-right-radius: 8px;\n}\n\n.header-title {\n\tmargin: 0;\n\tfont-size: 25px;\n}\n\n.search-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tpadding: 15px 25px;\n\tgap: 10px;\n}\n\n.filter-header-container {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap-reverse;\n\tgap: 30px;\n}\n\n.search-title {\n\tfont-size: 22px;\n\tmargin: 0;\n}\n\n.search-group {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n\tflex: 1;\n\tmin-width: 200px;\n}\n\n.search-group label {\n\tmargin-bottom: 5px;\n\tfont-size: 18px;\n}\n\n.search-group input,\n.search-group select {\n\tmax-width: 300px;\n\theight: 50px;\n\tpadding: 8px;\n\tborder-radius: 4px;\n\tfont-size: 18px;\n}\n\n.filter-button-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.filter-button {\n\tbackground-color: var(--success-color);\n\twidth: 100px;\n\theight: 40px;\n\tfont-size: 1rem;\n}\n\n.filter-button:hover {\n\tbackground-color: rgb(5, 142, 5);\n}\n\n.card-body {\n\tpadding: 25px;\n}\n\n.professors-table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\n\n.professors-table th,\n.professors-table td {\n\tborder: 1px solid #ddd;\n\tpadding: 10px;\n\ttext-align: center;\n\tfont-size: 18px;\n}\n\n.professors-table th {\n\tbackground-color: #f2f2f2;\n\tfont-weight: bold;\n}\n\n.professors-table tr:nth-child(even) {\n\tbackground-color: #f9f9f9;\n}\n\n.last-name {\n\twidth: 10%;\n}\n\n.prof-number {\n\twidth: 6%;\n}\n\n.faculty {\n\twidth: 10%;\n}\n\n.department {\n\twidth: 12%;\n}\n\n.scientific-rank {\n\twidth: 6%;\n}\n\n.action-table {\n\twidth: 25%;\n}\n\n.actions {\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 10px;\n}\n\n.action-button {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 6px 12px;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tfont-size: 14px;\n\twidth: 85px;\n}\n\n.action-button.delete {\n\tbackground-color: var(--danger-color);\n\tcolor: white;\n}\n\n.action-button.suspend {\n\tbackground-color: var(--label-color);\n\tcolor: white;\n}\n\n.action-button.view {\n\tbackground-color: rgb(0, 88, 189);\n\tcolor: white;\n}\n\n.action-button.update {\n\tbackground-color: rgb(80, 200, 196);\n\tcolor: white;\n}\n\n.no-data {\n\ttext-align: center;\n\tpadding: 20px;\n}\n\n.pagination-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-top: 30px;\n}\n\n.pagination-btn {\n\tpadding: 5px 10px;\n\tmargin: 0 5px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 4px;\n\tbackground-color: #fff;\n\tcursor: pointer;\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.pagination-btn.active {\n\tbackground-color: var(--primary-color);\n\tcolor: #fff;\n}\n\n.pagination-btn:disabled {\n\tbackground-color: #f4f4f4;\n\tcursor: not-allowed;\n}\n\n.dialog-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.dialog {\n\tbackground-color: white;\n\tpadding: 20px;\n\tborder-radius: 8px;\n\twidth: 400px;\n}\n\n.dialog-title {\n\tfont-size: 25px;\n}\n\n.dialog-content {\n\tmargin-bottom: 20px;\n\tfont-size: 20px;\n}\n\n.dialog-actions {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 10px;\n}\n\n.dialog-button {\n\tpadding: 8px 16px;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tcolor: white;\n\tfont-size: 1rem;\n}\n\n.dialog-button.cancel {\n\tbackground-color: var(--label-color);\n}\n\n.dialog-button.confirm {\n\tbackground-color: var(--danger-color);\n}\n\n.dialog-button.active {\n\tbackground-color: var(--success-color);\n}\n\n@media (max-width: 1200px) {\n\t.professors-list-container {\n\t\theight: 100vh;\n\t}\n\n\t.search-group input,\n\t.search-group select {\n\t\theight: 45px;\n\t\tfont-size: 20px;\n\t}\n\n\t.filter-button {\n\t\theight: 35px;\n\t}\n\n\t.actions {\n\t\tflex-wrap: wrap;\n\t}\n}\n\n@media (max-width: 1090px) {\n\t.professors-list-container {\n\t\theight: 150vh;\n\t}\n}\n\n@media (max-width: 945px) {\n\t.search-group label {\n\t\tfont-size: 1rem;\n\t}\n\n\t.search-group input,\n\t.search-group select {\n\t\theight: 35px;\n\t\tfont-size: 1rem;\n\t}\n\n\t.filter-button {\n\t\twidth: 85px;\n\t\theight: 30px;\n\t\tfont-size: 1rem;\n\t}\n\n\t.professors-table th,\n\t.professors-table td {\n\t\tfont-size: 16px;\n\t\tpadding: 8px;\n\t}\n\n\t.action-button {\n\t\twidth: 60px;\n\t\tfont-size: 12px;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.professors-list-container {\n\t\theight: 100vh;\n\t}\n\n\t.header-title {\n\t\tfont-size: 20px;\n\t}\n\n\t.search-title {\n\t\tfont-size: 18px;\n\t}\n\n\t.search-group label {\n\t\tfont-size: 13px;\n\t}\n\n\t.search-group input,\n\t.search-group select {\n\t\theight: 30px;\n\t\tfont-size: 13px;\n\t}\n\n\t.filter-button {\n\t\twidth: 60px;\n\t\theight: 25px;\n\t\tfont-size: 13px;\n\t}\n\n\t.card-body {\n\t\tpadding: 10px;\n\t}\n\n\t.professors-table th,\n\t.professors-table td {\n\t\tfont-size: 12px;\n\t\tpadding: 2px;\n\t}\n\n\t.actions {\n\t\tgap: 3px;\n\t}\n\n\t.action-button {\n\t\twidth: 45px;\n\t\tfont-size: 8px;\n\t\tpadding: 3px 6px;\n\t}\n\n\t.pagination-btn {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tfont-size: 10px;\n\t}\n\n\t.dialog {\n\t\twidth: 300px;\n\t}\n\n\t.dialog-title {\n\t\tfont-size: 20px;\n\t}\n\n\t.dialog-content {\n\t\tmargin-bottom: 10px;\n\t\tfont-size: 1rem;\n\t}\n\n\t.dialog-button {\n\t\tpadding: 4px 8px;\n\t\tfont-size: 12px;\n\t}\n}\n\n@media (max-width: 576px) {\n\t.professors-card {\n\t\theight: 60vh;\n\t}\n\n\t.professors-card {\n\t\twidth: 100%;\n\t\theight: 75vh;\n\t}\n\n\t.card-header {\n\t\tpadding: 10px;\n\t}\n\n\t.header-title {\n\t\tfont-size: 18px;\n\t}\n\n\t.search-container {\n\t\tmargin-bottom: 120px;\n\t}\n\n\t.search-title {\n\t\tfont-size: 1rem;\n\t}\n\n\t.search-container {\n\t\tpadding: 10px;\n\t\tgap: 0;\n\t\theight: 60px;\n\t}\n\n\t.search-group label {\n\t\tfont-size: 10px;\n\t}\n\n\t.search-group input,\n\t.search-group select {\n\t\theight: 25px;\n\t\twidth: 60%;\n\t\tfont-size: 10px;\n\t}\n\n\t.filter-button {\n\t\twidth: 45px;\n\t\theight: 20px;\n\t\tfont-size: 10px;\n\t}\n\n\t.card-body {\n\t\tpadding: 10px;\n\t}\n\n\t.professors-table th,\n\t.professors-table td {\n\t\tfont-size: 10px;\n\t\tpadding: 2px;\n\t}\n\n\t.actions {\n\t\tgap: 1px;\n\t}\n\n\t.action-button {\n\t\twidth: 35px;\n\t\tfont-size: 8px;\n\t\tpadding: 2px 4px;\n\t}\n\n\t.pagination-btn {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tfont-size: 8px;\n\t}\n\n\t.dialog {\n\t\twidth: 200px;\n\t}\n\n\t.dialog-title {\n\t\tfont-size: 1rem;\n\t}\n\n\t.dialog-content {\n\t\tmargin-bottom: 0;\n\t\tfont-size: 13px;\n\t}\n\n\t.dialog-button {\n\t\tpadding: 3px 6px;\n\t\tfont-size: 10px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
